import { DEFAULT_PRODUCT_MEDIA_ORIGIN } from './staticAssetConfig'

/**
 * @description 将富文本 HTML 中的默认 OSS 根地址替换为配置的媒体域名（与 NUXT_PUBLIC_PRODUCT_IMAGE_CDN_ORIGIN 等一致）
 * @reason Edge/Safari 等对「第三方」域名会提示 Tracking Prevention / 存储隔离；若 OSS 已绑定与主站同 eTLD+1 的自定义域名，在此配置后可减少跨站与控制台提示
 * @param {string} html - 原始 HTML
 * @param {string} [preferredOriginRaw] - 目标根地址，如 https://media.example.com（须与 bucket 路径一致）
 * @returns {string}
 */
export function rewriteRichTextOssUrls(html, preferredOriginRaw) {
  if (!html || typeof html !== 'string') return html
  const preferred = String(preferredOriginRaw || '')
    .trim()
    .replace(/\/+$/g, '')
  const defaultOrigin = DEFAULT_PRODUCT_MEDIA_ORIGIN.replace(/\/+$/g, '')
  if (!preferred || preferred === defaultOrigin) return html
  return html.split(defaultOrigin).join(preferred)
}
